/*
 UserStatistics.js component
 url match: statistics/usage
 Displays statistics of an agent/user
*/
import { withRouter } from 'react-router-dom';
import React from 'react';
import { inject, observer } from 'mobx-react';
import { withStyles } from '@material-ui/core/styles';
import { statisticsStyles } from '../../Styles/statisticsStyles';
import { ReactSVG } from 'react-svg'
import Images from '../../Theme/Images';
import Header from '../../Common/Header'
import Typography from '@material-ui/core/Typography';
import Loader from 'react-loader-spinner'
import Moment from 'moment';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { DateRangePicker } from 'react-date-range';
import Button from '@material-ui/core/Button';
import '../../Styles/datePickerStyles.css'

@inject('statisticsStore', 'userStore', 'commonStore')
@observer
class UserStatistics extends React.Component {
    state = {
        startDate: Moment(new Date(new Date().getFullYear(), new Date().getMonth(), 1)).format('DD-MMM-YYYY'),
        endDate: Moment(new Date()).format('DD-MMM-YYYY'),
        showDatePicker: false,
        selectionRange: {
            startDate: new Date(),
            endDate: new Date(),
            key: 'selection',
        },
        tableHeader: [
            { name: 'Agent', allowSort: true, sortDirection: 1 },
            { name: 'Docs Assigned', allowSort: false, sortDirection: 1 },
            { name: 'Docs Reviewed', allowSort: false, sortDirection: 1 },
            { name: 'Docs Exported', allowSort: false, sortDirection: 1 }

        ]

    }

    componentDidMount() {
        this.props.commonStore.setActiveTab('stats');
        let startDate = Moment(new Date(new Date().getFullYear(), new Date().getMonth(), 1)).format('YYYY-MM-DD')
        let endDate = Moment(new Date()).format('YYYY-MM-DD')
        this.props.statisticsStore.getStatusReport(startDate, endDate)
    }

    renderCountData = () => {
        const { classes } = this.props;
        const { countData, totalCount } = this.props.statisticsStore;
        return (
            <div style={{ display: 'flex' }}>
                <div className={classes.usageCountDiv} style={{ borderLeft: 'solid 4px #0f7fd3' }}>
                    <div style={{ display: 'flex' }}>
                        <ReactSVG src={Images.importSmall} />
                        <div style={{ margin: '0vh 1vw', color: '#646974' }}>
                            <div style={{ color: 'white' }}>{totalCount}</div>
                        Uploaded
                    </div>
                    </div>
                </div>
                <div className={classes.usageCountDiv} style={{ borderLeft: 'solid 4px #ff4652' }}>
                    <div style={{ display: 'flex' }}>
                        <ReactSVG src={Images.draft} />
                        <div style={{ margin: '0vh 1vw', color: '#646974' }}>
                            <div style={{ color: 'white' }}>{countData['REVIEW_PENDING']}</div>
                        In Draft
                    </div>
                    </div>
                </div>
                <div className={classes.usageCountDiv} style={{ borderLeft: 'solid 4px #04bfb4' }}>
                    <div style={{ display: 'flex' }}>
                        <ReactSVG src={Images.reviewed} />
                        <div style={{ margin: '0vh 1vw', color: '#646974' }}>
                            <div style={{ color: 'white' }}>{countData['REVIEW_COMPLETE']}</div>
                        Reviewed
                    </div>
                    </div>
                </div>
                <div className={classes.usageCountDiv} style={{ borderLeft: 'solid 4px #bba3f6' }}>
                    <div style={{ display: 'flex' }}>
                        <ReactSVG src={Images.exported} />
                        <div style={{ margin: '0vh 1vw', color: '#646974' }}>
                            <div style={{ color: 'white' }}>{countData['EXPORTED']}</div>
                        Exported
                    </div>
                    </div>
                </div>
            </div>
        )
    }

    handleSelect = (ranges) => {
        this.setState({
            selectionRange: ranges.selection,
            startDate: Moment(ranges.selection.startDate).format('DD-MMM-YYYY'),
            endDate: Moment(ranges.selection.endDate).format('DD-MMM-YYYY')
        })

    }

    getStats = () => {
        this.setState({ showDatePicker: false })
        const { startDate, endDate } = this.state
        let s = Moment(startDate).format('YYYY-MM-DD')
        let e = Moment(endDate).format('YYYY-MM-DD')
        this.props.statisticsStore.getStatusReport(s, e)
    }

    openDatePicker = () => {
        this.setState({ showDatePicker: true })
    }

    renderTableHeader = () => {
        const { tableHeader } = this.state;
        const { classes } = this.props;
        return (
            <TableHead>
                {
                    tableHeader.map((row, index) => (
                        (
                            <TableCell className={classes.tableHeader} align="left">
                                <div style={{ display: 'flex' }}>
                                    {row.name}
                                    {row.allowSort ? (row.sortDirection === 1 ?
                                        <ReactSVG className={classes.sortIcons} src={Images.sort} onClick={(e) => this.sortList(-1, index, row.type)} /> :
                                        <ReactSVG className={classes.sortIcons} src={Images.reverseSort} onClick={(e) => this.sortList(1, index, row.type)} />)

                                        : null}
                                </div>
                            </TableCell>
                        )
                    ))
                }
            </TableHead>

        )
    }

    renderTableContent = () => {
        const { classes } = this.props;
        const { userStats } = this.props.statisticsStore;
        const { user } = this.props.userStore
        return (
            <TableBody>
                <TableRow key="userStats1" className={classes.tableRow}>
                    <TableCell className={classes.tableData} align="left">{user.userFullName}</TableCell>
                    <TableCell className={classes.tableData} align="left">{userStats.assigned}</TableCell>
                    <TableCell className={classes.tableData} align="left">{userStats.reviewed}</TableCell>
                    <TableCell className={classes.tableData} align="left">{userStats.exported}</TableCell>
                </TableRow>
            </TableBody>

        )
    }
    
    downloadReport = () => {
        this.props.statisticsStore.downloadReport()
    }

    render() {
        const { classes } = this.props;
        const { inProgress } = this.props.statisticsStore;
        const { startDate, endDate, selectionRange, showDatePicker } = this.state;
        if (inProgress)
            return (
                <div style={{ height: '100%' }}>
                    <div><Loader height={100} width={100} color={this.props.theme.palette.blue} className={classes.loading} timeout={100000} /></div>
                </div>
            )
        return (
            <div style={{ height: '100%' }}>
                <div className={classes.outerContainer}>
                    <div style={{ flex: 2, display: 'flex', justifyContent: 'space-between', marginTop: '-1vh' }}><Typography className={classes.heading}>Statistics</Typography>
                        <div style={{ cursor: 'pointer' }}>

                            <div className="rowFlex">
                                <ReactSVG src={Images.download} onClick={(e) => this.downloadReport()} style={{ marginTop: '2vh', marginRight: '1VW' }} />
                                <Button variant="contained" className={classes.button} type="submit" onClick={this.openDatePicker} fullWidth>
                                    {`${startDate}  -   ${endDate}`}
                                </Button>
                                {showDatePicker ? <ReactSVG style={{ marginTop: '3vh' }} src={Images.docRight} onClick={(e) => this.getStats()} /> : null}
                            </div>
                            {showDatePicker ?
                                <div style={{ position: 'absolute', left: '55%', top: '10%' }} >
                                    <DateRangePicker direction="horizontal"
                                        showSelectionPreview={true}
                                        moveRangeOnFirstSelection={false}
                                        months={1}
                                        ranges={[selectionRange]}
                                        onChange={this.handleSelect}
                                        disabled={true}
                                        color="yellow"
                                    />
                                </div> : null
                            }

                        </div>
                    </div>
                    <Header></Header>
                </div>
                <div className={classes.innerContainer}>
                    <div className={classes.subHeading}>Document Usage Reports</div>
                    <div className="colFlex">
                        {this.renderCountData()}
                        <div className="rowFlex">
                            <div style={{ height: '100%'}}>
                                <div >
                                    <div className={classes.subHeading}>My Task</div>
                                    <TableContainer style={{ height: '90%', backgroundColor: this.props.theme.palette.dark }} elevation={0} component={Paper}>
                                        <Table className={classes.table} style={{width: '596px'}} aria-label="simple table">
                                            {this.renderTableHeader()}
                                            {this.renderTableContent()}
                                        </Table>
                                    </TableContainer>
                                    <div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div >

        )
    }
}

export default withStyles(statisticsStyles, { withTheme: true })(withRouter(UserStatistics));
